const options = {
  5: "bg-violet-100/5",
  10: "bg-violet-100/10",
  25: "bg-violet-100/25",
  50: "bg-violet-100/50",
  75: "bg-violet-100/75",
  90: "bg-violet-100/90",
  100: "bg-violet-100",
};

const from = {
  5: "from-violet-100/5",
  10: "from-violet-100/10",
  25: "from-violet-100/25",
  50: "from-violet-100/50",
  75: "from-violet-100/75",
  90: "from-violet-100/90",
  100: "from-violet-100",
};

export default function getBackgroundViolet100(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
